import { Delete, Edit, PersonAdd } from "@mui/icons-material";
import { Avatar, Button, Dialog, DialogContent, DialogTitle, Divider, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Menu, MenuItem, TextField, Typography } from "@mui/material";
import { UserService } from "../../../services/authService";
import { ProfileDto } from "../../../types/UserToken";
import { ChannelMemberDto } from "../../../types/channelMember";

interface MemberDialogProps {
  membersDialogOpen: boolean;
  setMembersDialogOpen: (open: boolean) => void;
  isAdmin: boolean;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  searchResults: ProfileDto[];
  setSearchResults: (results: ProfileDto[]) => void;
  channelMembers: ChannelMemberDto[];
  handleInvite: (user: ProfileDto) => void;
  handleMemberAction: (action: "remove" | "promote") => void;
  selectedMember: ChannelMemberDto | null;
  menuAnchorEl: HTMLElement | null;
  setMenuAnchorEl: (el: HTMLElement | null) => void;

}

export const MembersDialog = (props: MemberDialogProps) => {
    const {
        membersDialogOpen,
        setMembersDialogOpen,
        isAdmin,
        searchTerm,
        setSearchTerm,
        searchResults,
        setSearchResults,
        channelMembers,
        handleInvite,
        handleMemberAction,
        selectedMember,
        menuAnchorEl,
        setMenuAnchorEl
    } = props;

    return (
    <Dialog
        open={membersDialogOpen}
        onClose={() => setMembersDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Invitar miembros al canal
          {isAdmin && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Como administrador, puedes gestionar los miembros
            </Typography>
          )}
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Buscar miembros"
            variant="outlined"
            fullWidth
            size="small"
            value={searchTerm}
            onChange={async (e) => {
              const value = e.target.value;
              setSearchTerm(value);

              if (value.length >= 2) {
                try {
                  const results = await UserService.searchUsersForChannels(
                    value
                  );

                  const mappedResults: ProfileDto[] = results.map(
                    (user: any) => ({
                      ...user,
                      avatarUrl: user.profilePicture || "",
                    })
                  );

                  const resultsWithoutMembers = mappedResults.filter(
                    (u) =>
                      !channelMembers.some(
                        (m) => m.profileId === u.userProfileId
                      )
                  );
                  console.log("Resultados de búsqueda:", resultsWithoutMembers);

                  setSearchResults(resultsWithoutMembers);
                } catch (err) {
                  console.error("Error al buscar usuarios:", err);
                  setSearchResults([]);
                }
              } else {
                setSearchResults([]);
              }
            }}
            sx={{ mb: 2 }}
          />
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" gutterBottom>
              Resultados de búsqueda
            </Typography>
            <List>
              {searchResults.length > 0 ? (
                <>
                  <Divider sx={{ my: 2 }} />
                  <List>
                    {searchResults.map((user) => (
                      <ListItem key={user.userProfileId}>
                        <ListItemAvatar>
                          <Avatar src={user.avatarUrl || "/placeholder.svg"} />
                        </ListItemAvatar>
                        <ListItemText primary={user.username} />
                        <ListItemSecondaryAction>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleInvite(user)}
                            startIcon={<PersonAdd />}
                          >
                            invitar
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No hay resultados
                </Typography>
              )}
            </List>
          </>
        </DialogContent>
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={() => setMenuAnchorEl(null)}
        >
          <MenuItem onClick={() => handleMemberAction("promote")}>
            {selectedMember?.role === "Member" ? (
              <>
                <Edit fontSize="small" sx={{ mr: 1 }} />
                Promover a Moderador
              </>
            ) : (
              <>
                <Edit fontSize="small" sx={{ mr: 1 }} />
                Quitar Promoción
              </>
            )}
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => handleMemberAction("remove")}
            sx={{ color: "error.main" }}
          >
            <Delete fontSize="small" sx={{ mr: 1 }} />
            Eliminar del canal
          </MenuItem>
        </Menu>
      </Dialog>
      );
    }